import { FaSortAlphaDown as SortDownIcon } from 'react-icons/fa';

export default SortDownIcon;
